import { helper } from '@ember/component/helper';

import { themeClassNames } from 'webapp/models-custom/theme';

const themeClasses = helper(([theme]: [string | null | undefined]) => themeClassNames(theme));

export default themeClasses;
